import { Injectable } from '@angular/core';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { LoggingSink, LogSeverity } from '../models/logging-sink';
import { ConsoleLogging, FileLogging } from '../../environment-configuration/logging.configuration.js';
import { ConsoleLoggingSink } from './console-logging.service';
import { FileLoggingSink } from './file-logging.service';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private static sinks: LoggingSink[] = [];

  public constructor(private readonly environmentService: EnvironmentConfigurationService) {}
  public Critical(message: string): void {
    this.Log(LogSeverity.CRITICAL, message);
  }

  public Error(message: string): void {
    this.Log(LogSeverity.ERROR, message);
  }

  public Warning(message: string): void {
    this.Log(LogSeverity.WARNING, message);
  }

  public Info(message: string): void {
    this.Log(LogSeverity.INFO, message);
  }

  private Log(severity: LogSeverity, message: string): void {
    if (LoggingService.sinks.length < 1) {
      this.Initialize();

      const configuration = this.environmentService.configurationSettings;
      this.Info(`Logging initialized
      Client version: ${configuration?.releaseVersion}
      Environment: ${configuration?.environmentName}
      Main location: ${configuration?.mainLocation}
      `);
    }
    // no fractionalSecondDigits in DateTimeFormatOptions (typescript es2020.intl)
    const date = new Date();
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const timestamp = `${date.toLocaleString('sv-SE', { timeZone: 'UTC' })},${date.getUTCMilliseconds().toString().padStart(3, '0')}`;
    LoggingService.sinks.forEach((x) => {
      x.log(severity, timestamp, message);
    });
  }

  private Initialize(): void {
    const tempSinks: LoggingSink[] = [];
    if (ConsoleLogging) {
      tempSinks.push(new ConsoleLoggingSink());
    }
    if (FileLogging) {
      tempSinks.push(new FileLoggingSink());
    }
    LoggingService.sinks = tempSinks;
  }
}
